import { useMemo } from "react";

interface MessageProps {
  label?: string;
  text: string;
  type: "secondary" | "info" | "success" | "danger" | "warning";
}

const styles: Record<MessageProps["type"], string> = {
  secondary: "bg-surface-sunken border-line-subtle text-content-secondary",
  info: "bg-accent-surface border-accent/20 text-accent-content",
  success: "bg-positive-surface border-positive/20 text-positive-content",
  danger: "bg-negative-surface border-negative/20 text-negative-content",
  warning: "bg-warning-surface border-warning/20 text-warning-content",
};

export default function Message({ label, text, type }: MessageProps) {
  const style = useMemo(() => styles[type], [type]);

  return (
    <div className={`mt-2 border text-sm rounded-lg p-4 ${style}`} role="alert">
      <span className="font-bold">{label}</span> {text}
    </div>
  );
}
